import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './main/Home';
import About from './menu/About';
import Menu from './menu/Menu';
import News from './menu/News';
import Contact from './menu/Contact';
import Reservation from './menu/Reservation';
import { TransitionProvider } from './main/PageTransition';
// import Popup from './main/popup';

function App() {
  return (
    <Router>
      <TransitionProvider>
        <div className="App">
          {/* <Popup /> */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/reservation" element={<Reservation />} />
          </Routes>
        </div>
      </TransitionProvider>
    </Router>
  );
}

export default App;
